module.exports = {
  BANK_ACCOUNT_TYPE: {
    TRULY_MANAGED: 'TRULY_MANAGED',
    EXTERNAL: 'EXTERNAL',
    EXTERNAL_LINKED: 'EXTERNAL_LINKED'
  },
  PAYMENT_TYPE: {
    EXPRESS: 'EXPRESS',
    INSTANT: 'INSTANT',
    WIRE: 'WIRE'
  },
  PAYMENT_PREFERENCE: {
    EXPRESS: 'EXPRESS',
    INSTANT: 'INSTANT',
    WIRE: 'WIRE'
  },
  ACCOUNT_TYPE: {
    SAVINGS: 'SAVINGS',
    CHECKING: 'CHECKING'
  },
  ROUTING_CODE_TYPE: {
    BIC_SWIFT: 'BIC_SWIFT',
    SORT_CODE: 'SORT_CODE',
    ACH: 'ACH',
    BSB_CODE: 'BSB_CODE',
    INSTITUTION_NUMBER: 'INSTITUTION_NUMBER',
    TRANSIT_CODE: 'TRANSIT_CODE',
    BANK_CODE: 'BANK_CODE',
    BRANCH_CODE: 'BRANCH_CODE',
    CLABE: 'CLABE',
    CNAPS: 'CNAPS',
    FEDWIRE: 'FEDWIRE',
    SEPA: 'SEPA',
    IFSC: 'IFSC',
    IBAN_REGULAR: 'IBAN_REGULAR'
  },
  BANK_ACCOUNT_STATUS: {
    ACTIVE: 'ACTIVE',
    INACTIVE: 'INACTIVE',
    REQUESTED: 'REQUESTED'
  },
  IDENTIFIER: {
    TRULY_USER: 'TRULY_USER',
    LIRA_USER: 'LIRA_USER',
    SYSTEM: 'SYSTEM'
  },
  DISPLAY_NAME: {
    ACCOUNT_HOLDER_NAME: 'Account Name',
    ACCOUNT_NUMBER: 'Account No.',
    IBAN: 'IBAN',
    BANK_NAME: 'Institution Name',
    BANK_ADDRESS: 'Address',
    BANK_COUNTRY: 'Country'
  },
  SYSTEM_USER: '0'
};
